






























import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { NumberLayer } from '@/model/document2/page/surface/design/layer/numberLayer';
import { TextInfo } from '@/utilityModels/textInfo';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { DebugHelper } from "@/helper/debugHelper";

@Component({
    components: {
    },
})
export default class NumberLayerDrawer extends Vue
{
    // 文字の高さに対する下線の割合
    static readonly UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT = 1 / 18.0;

    // 最小フォントサイズ(pt)
    static readonly MIN_FONT_SIZE = 1;
    static readonly MAX_FONT_SIZE = 720;

    @Prop() private layer!: NumberLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    // 直接印刷ではクライアントで処理するのでサーバー用のフォントになると困る
    @Prop({default : false}) private isRenderingOnClient!: boolean;

    // マウント済みフラグ
    private ismounted = false;
    mounted() { this.ismounted = true; }

    // 不透明度(0 ~ 1.0)
    private get opacity()
    {
        var value = this.layer.opacity / 100;
        if(value < 0) { value = 0; }
        if(value > 1) { value = 1; }
        return value;
    }

    // 文字情報配列
    private get characterInfoArray() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string                   // UUID
    }>
    {
        // テキスト方向により返す情報配列を振り分ける
        return this.layer.textOrientation == 1 ? this.characterInfoArrayVertical : this.characterInfoArrayHorizontal;
    }

    // 横書き
    private get characterInfoArrayHorizontal() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string                   // UUID
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return new Array(); }

        if(this.layer.autoSize)
        {
            // 自動サイズ設定する
            var tryFontSize = 1;
            var tryBeforeFontSize = 1;
            var step = 20;
            while(true)
            {
                // 仮に配置してみる
                array = this.getCharacterInfoArrayHorizontal(this.layer.autoNewLine, true, tryFontSize);
                // 文字群の幅・高さを求める
                var minX = 0;
                var minY = 0;
                var maxX = 0;
                var maxY = 0;
                for(var i = 0; i < array.length; ++i)
                {
                    var info = array[i];
                    if(i == 0 || info.x < minX) { minX = info.x; }
                    if(i == 0 || info.y < minY) { minY = info.y; }
                    if(i == 0 || info.x + info.width > maxX) { maxX = info.x + info.width; }
                    if(i == 0 || info.y + info.height > maxY) { maxY = info.y + info.height; }
                }
                var totalWidth = maxX - minX;
                var totalHeight = maxY - minY;

                // 誤差吸収
                totalWidth = Math.floor(totalWidth);
                totalHeight = Math.floor(totalHeight);
                if(totalWidth > this.layer.width * this.scale || totalHeight > this.layer.height * this.scale)
                {
                    // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                    if(step == 20) { step = 10; }
                    else if(step == 10) { step = 5; }
                    else if(step == 5) { step = 2; }
                    else if(step == 2) { step = 1; }
                    else if(step == 1) { step = 0.3; }
                    else if(step == 0.3) { step = 0.1; }
                    else
                    {
                        // 以前のサイズで決定する
                        break;
                    }

                    // 以前のサイズにstepを加えて再チャレンジする
                    tryFontSize = tryBeforeFontSize + step;
                }
                else
                {
                    // レイヤー領域を超えない。stepを加えてもう一度計測する
                    tryBeforeFontSize = tryFontSize;
                    tryFontSize += step;
                }

                if(tryFontSize <= 0)
                {
                    tryFontSize = NumberLayerDrawer.MIN_FONT_SIZE;
                    break;
                }

                if(tryFontSize >= NumberLayerDrawer.MAX_FONT_SIZE)
                {
                    tryFontSize = NumberLayerDrawer.MAX_FONT_SIZE;
                    tryBeforeFontSize = tryFontSize;
                    break;
                }
            }

            // フォントサイズ決定
            array = this.getCharacterInfoArrayHorizontal(this.layer.autoNewLine, true, tryBeforeFontSize);
        }
        else
        {
            array = this.getCharacterInfoArrayHorizontal(true, false);
        }

        return array;
    }

    // 横書き配置
    // isAutoNewLine : 自動改行する falseの場合はレイヤーの文字列での改行以外で改行しない
    // isSameFontSize : すべて同じフォントサイズを使用する
    // fontSize : 同じフォントサイズを使用する場合のフォントサイズ(pt)
    private getCharacterInfoArrayHorizontal(isAutoNewLine = true, isSameFontSize = false, fontSize = 1) : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string                   // UUID
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        // 共通フォントサイズをビューのサイズに変更
        var scaledSameFontSize = UnitHelper.convert(fontSize, "pt", "mm") * this.scale;

        // スタート位置
        var x = this.layer.x * this.scale + this.offsetX;
        var y = this.layer.y * this.scale + this.offsetY;
        var maxHeight = 0;
        var numberInLine = 0;
        var renderLineIndex = 0;
        var renderCharacterIndex = 0;
        for(var lineIndex = 0; lineIndex < 1; ++lineIndex)
        {
            var characterCount = this.layer.getText().length;
            {
                for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
                {
                    var character = this.layer.getText().substr(characterIndex, 1);
                    {
                        // この文字の大きさを測る

                        var scaledFontSize = isSameFontSize ? scaledSameFontSize : UnitHelper.convert(this.layer.textInfo.fontSize, "pt", "mm") * this.scale;
                        var isHankaku = StringHelper.isHankaku(character);
                        var size = this.calcTextSize(character, scaledFontSize, this.layer.textInfo.fontId, this.layer.textInfo.bold, this.layer.textInfo.italic, false);
                        // 幅をこの文字の設定に変更
                        size.width *= this.layer.textInfo.letterWidth / 100;
                        if(isAutoNewLine)
                        {
                            if(x + size.width > this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale)
                            {
                                // 描画位置が枠を超えてしまうので改行
                                // 改行前に同じ行にいる文字のy座標を下方向にずらす ... 描画指定位置が左下になるため
                                for(var i = 0; i < numberInLine; ++i)
                                {
                                    var arrayIndex = array.length - 1 - i;
                                    if(arrayIndex >= 0)
                                    {
                                        array[arrayIndex].y += maxHeight;
                                    }
                                }
                                // 行間に従って送る
                                y += maxHeight * this.layer.lineSpacing / 100;
                                x = this.layer.x * this.scale + this.offsetX;
                                renderLineIndex++;
                                maxHeight = 0;
                                numberInLine = 0;
                                renderCharacterIndex = 0;
                            }
                        }

                        array.push({
                            character : character,
                            lineIndex : lineIndex,
                            characterIndex : characterIndex,
                            textInfo : this.layer.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : this.layer.textInfo.letterWidth,
                            renderLineIndex : renderLineIndex,
                            renderCharacterIndex : renderCharacterIndex,
                            uuid : UuidHelper.getUuid()
                        });
                        // 文字送り
                        x += size.width;
                        if(this.layer.horizontalAlignment != 3)
                        {
                            // 文字間を空ける *水平方向均等以外
                            x += UnitHelper.convert(this.layer.textInfo.letterSpacing, "pt", "mm") * this.scale;
                        }
                        numberInLine++;
                        renderCharacterIndex++;
                        // 最大高さ更新
                        maxHeight = Math.max(maxHeight, size.height);
                    }
                }
            }
            // 改行
            // 改行前に同じ行にいる文字のy座標を下方向にずらす ... 描画指定位置が左下になるため
            for(var i = 0; i < numberInLine; ++i)
            {
                var arrayIndex = array.length - 1 - i;
                if(arrayIndex >= 0)
                {
                    array[arrayIndex].y += maxHeight;
                }
            }
            // 行間に従って送る
            y += maxHeight * this.layer.lineSpacing / 100;
            x = this.layer.x * this.scale + this.offsetX;
            renderLineIndex++;
            maxHeight = 0;
            numberInLine = 0;
            renderCharacterIndex = 0;
        }

        // 水平方向位置
        if(this.layer.horizontalAlignment != 0)
        {
            // 左揃え以外
            var tempArray = new Array();
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];

                // 一時配列にアイテムを加える
                tempArray.push(item);

                // 行の最後かどうかしらべる
                var isLastInLine = false;
                if(i == array.length - 1)
                {
                    // 最後のアイテム
                    isLastInLine = true;
                }
                else
                {
                    // 次のアイテムの行番号が異なる
                    isLastInLine = item.renderLineIndex != array[i + 1].renderLineIndex;
                }

                if(isLastInLine)
                {
                    // 行の最後なら水平揃えをする
                    // 行の長さ = (行最後のアイテムのx座標 + 幅) - (行最初のアイテムのx座標)
                    var lineWidth = tempArray[tempArray.length - 1].x + tempArray[tempArray.length - 1].width - tempArray[0].x;

                    if(this.layer.horizontalAlignment == 1 || this.layer.horizontalAlignment == 2)
                    {
                        // 中央/右揃えは同じ値だけx座標をずらす
                        var dx = 0;
                        if(this.layer.horizontalAlignment == 1)
                        {
                            // 中央揃え (レイヤーの幅 - 行の長さ) / 2
                            dx = (this.layer.width * this.scale - lineWidth) / 2;
                        }
                        else if(this.layer.horizontalAlignment == 2)
                        {
                            // 右揃え レイヤーの幅 - 行の長さ
                            dx = this.layer.width * this.scale - lineWidth;
                        }
                        for(var tempItem of tempArray)
                        {
                            tempItem.x += dx;
                        }
                    }
                    else if(this.layer.horizontalAlignment == 3)
                    {
                        // 均等揃えは字間を再設定する
                        // 文字数をカウントする。ただし半角英数記号は並びあっている限りは一文字扱いする
                        // "abc "で1文字
                        var textCount = 0;
                        for(var t = 0; t < tempArray.length; ++t)
                        {
                            var item = tempArray[t];
                            if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                            {
                                // 半角英数記号にマッチング
                                // 末尾 or 次の文字が半角英数記号以外なら文字としてカウント
                                if(t == tempArray.length - 1 || (t < tempArray.length - 1 && !(tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t + 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else if(item.character == " ")
                            {
                                // 半角スペースにマッチング
                                // 最初 or 直前の文字が半角英数記号以外なら文字としてカウント
                                if(t == 0 || (t > 1 && !(tempArray[t - 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t - 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else
                            {
                                // 文字カウント
                                textCount++;
                            }
                        }

                        if(textCount > 1)
                        {
                            // 2文字以上のみ均等割を行う
                            var spacing = (this.layer.width * this.scale - lineWidth) / (textCount - 1);
                            // 字間を設定していく
                            var dx = 0;
                            for(var t = 0; t < tempArray.length; ++t)
                            {
                                var item = tempArray[t];
                                item.x += dx;

                                if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                                {
                                    // 半角英数記号にマッチング
                                    if(t < tempArray.length - 1 && tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) == null)
                                    {
                                        // 次の文字が半角英数記号以外
                                        dx += spacing;
                                    }
                                }
                                else
                                {
                                    dx += spacing;
                                }
                            }
                        }
                    }

                    // 一時配列クリア
                    tempArray = new Array();
                }
            }
        }

        // 垂直方向位置
        if(this.layer.verticalAlignment != 0)
        {
            // 上揃え以外
            // 全文字の一番上の座標・一番下の座標を求める
            var minY = 0;
            var maxY = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];
                if(i == 0 || item.y < minY) { minY = item.y; }
                if(i == 0 || item.y + item.height > maxY) { maxY = item.y + item.height; }
            }
            // 文字全体の高さ
            var allHeight = maxY - minY;
            // 同じ値だけy座標をずらす
            var dy = 0;
            if(this.layer.verticalAlignment == 1)
            {
                // 中央揃え (レイヤーの高さ - 文字全体の高さ) / 2;
                dy = (this.layer.height * this.scale - allHeight) / 2;
            }
            else if(this.layer.verticalAlignment == 2)
            {
                // 下揃え (レイヤーの高さ - 文字全体の高さ)
                dy = this.layer.height * this.scale - allHeight;
            }
            for(var item of array)
            {
                item.y += dy;
            }
        }

        return array;
    }

    // 縦書き
    private get characterInfoArrayVertical() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string                   // UUID
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        if(this.layer.autoSize)
        {
            // 自動サイズ設定する
            var tryFontSize = 1;
            var tryBeforeFontSize = 1;
            var step = 20;
            while(true)
            {
                // 仮に配置してみる
                array = this.getCharacterInfoArrayVertical(this.layer.autoNewLine, true, tryFontSize);
                // 文字群の幅・高さを求める
                var minX = 0;
                var minY = 0;
                var maxX = 0;
                var maxY = 0;
                for(var i = 0; i < array.length; ++i)
                {
                    var info = array[i];
                    if(i == 0 || info.x < minX) { minX = info.x; }
                    if(i == 0 || info.y < minY) { minY = info.y; }
                    if(i == 0 || info.x + info.width > maxX) { maxX = info.x + info.width; }
                    if(i == 0 || info.y + info.height > maxY) { maxY = info.y + info.height; }
                }
                var totalWidth = maxX - minX;
                var totalHeight = maxY - minY;

                if(totalWidth > this.layer.width * this.scale || totalHeight > this.layer.height * this.scale)
                {
                    // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                    if(step == 20) { step = 10; }
                    else if(step == 10) { step = 5; }
                    else if(step == 5) { step = 2; }
                    else if(step == 2) { step = 1; }
                    else if(step == 1) { step = 0.3; }
                    else if(step == 0.3) { step = 0.1; }
                    else
                    {
                        // 以前のサイズで決定する
                        break;
                    }

                    // 以前のサイズにstepを加えて再チャレンジする
                    tryFontSize = tryBeforeFontSize + step;
                }
                else
                {
                    // レイヤー領域を超えない。stepを加えてもう一度計測する
                    tryBeforeFontSize = tryFontSize;
                    tryFontSize += step;
                }

                if(tryFontSize <= 0)
                {
                    tryFontSize = NumberLayerDrawer.MIN_FONT_SIZE;
                    break;
                }

                if(tryFontSize >= NumberLayerDrawer.MAX_FONT_SIZE)
                {
                    tryFontSize = NumberLayerDrawer.MAX_FONT_SIZE;
                    tryBeforeFontSize = tryFontSize;
                    break;
                }
            }

            // フォントサイズ決定
            array = this.getCharacterInfoArrayVertical(this.layer.autoNewLine, true, tryBeforeFontSize);
        }
        else
        {
            array = this.getCharacterInfoArrayVertical(true, false);
        }

        return array;
    }

    // 縦書き配置
    // isAutoNewLine : 自動改行する falseの場合はレイヤーの文字列での改行以外で改行しない
    // isSameFontSize : すべて同じフォントサイズを使用する
    // fontSize : 同じフォントサイズを使用する場合のフォントサイズ(pt)
    private getCharacterInfoArrayVertical(isAutoNewLine = true, isSameFontSize = false, fontSize = 1) : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string                   // UUID
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        // 共通フォントサイズをビューのサイズに変更
        var scaledSameFontSize = UnitHelper.convert(fontSize, "pt", "mm") * this.scale;

        // スタート位置
        var x = (this.layer.x + this.layer.width) * this.scale + this.offsetX;
        var y = this.layer.y * this.scale + this.offsetY;
        var maxWidth = 0;
        var numberInLine = 0;
        var renderLineIndex = 0;
        var renderCharacterIndex = 0;
        // 縦中横での最大高さ
        var maxHeight = 0;
        // 縦中横で描画した幅
        var horizontalWidth = 0;
        for(var lineIndex = 0; lineIndex < 1; ++lineIndex)
        {
            var characterCount = this.layer.getText().length;
            {
                for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
                {
                    var character = this.layer.getText().substr(characterIndex, 1);
                    {
                        // この文字の大きさを測る

                        var scaledFontSize = isSameFontSize ? scaledSameFontSize : UnitHelper.convert(this.layer.textInfo.fontSize, "pt", "mm") * this.scale;
                        var isHankaku = StringHelper.isHankaku(character);
                        var size = this.calcTextSize(character, scaledFontSize, this.layer.textInfo.fontId, this.layer.textInfo.bold, this.layer.textInfo.italic, true);
                        // 高さをこの文字の設定に変更
                        size.height *= this.layer.textInfo.letterWidth / 100;
                        if(isAutoNewLine)
                        {
                            if(y + size.height > (this.layer.y + this.layer.height) * this.scale + this.offsetY)
                            {
                                // 描画位置が枠を超えてしまうので改行
                                // 改行前に同じ行にいる文字のx座標を左方向にずらす ... 描画指定位置が上中央になるため
                                // 縦中横の文字格納
                                var horizontalArray = new Array();
                                for(var i = 0; i < numberInLine; ++i)
                                {
                                    var arrayIndex = array.length - 1 - i;
                                    if(arrayIndex >= 0)
                                    {
                                        if(array[arrayIndex].textInfo.isHorizontalInVertical)
                                        {
                                            // 縦中横
                                            horizontalArray.push(array[arrayIndex]);
                                        }
                                        else
                                        {
                                            if(horizontalArray.length > 0)
                                            {
                                                var horizontalWidth = horizontalArray[0].x + horizontalArray[0].width - horizontalArray[horizontalArray.length - 1].x;
                                                var horizontalHeight = 0;
                                                for(var horizontal of horizontalArray)
                                                {
                                                    horizontalHeight = Math.max(horizontalHeight, horizontal.height);
                                                }
                                                for(var horizontal of horizontalArray)
                                                {
                                                    horizontal.x -= maxWidth / 2 + horizontalWidth / 2;
                                                    horizontal.y += horizontalHeight;
                                                }
                                                horizontalArray = new Array();
                                            }
                                            array[arrayIndex].x -= maxWidth / 2;
                                        }
                                    }
                                }
                                if(horizontalArray.length > 0)
                                {
                                    var horizontalWidth = horizontalArray[0].x + horizontalArray[0].width - horizontalArray[horizontalArray.length - 1].x;
                                    var horizontalHeight = 0;
                                    for(var horizontal of horizontalArray)
                                    {
                                        horizontalHeight = Math.max(horizontalHeight, horizontal.height);
                                    }
                                    for(var horizontal of horizontalArray)
                                    {
                                        horizontal.x -= maxWidth / 2 + horizontalWidth / 2;
                                        horizontal.y += horizontalHeight;
                                    }
                                    horizontalArray = new Array();
                                }
                                // 行間に従って送る
                                x -= maxWidth * this.layer.lineSpacing / 100;
                                y = this.layer.y * this.scale + this.offsetY;
                                renderLineIndex++;
                                maxWidth = 0;
                                numberInLine = 0;
                                renderCharacterIndex = 0;
                            }
                        }

                        array.push({
                            character : character,
                            lineIndex : lineIndex,
                            characterIndex : characterIndex,
                            textInfo : this.layer.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : this.layer.textInfo.letterWidth,
                            renderLineIndex : renderLineIndex,
                            renderCharacterIndex : renderCharacterIndex,
                            uuid : UuidHelper.getUuid()
                        });
                        {
                            // 文字送り
                            y += size.height;
                            // 最大幅更新
                            maxWidth = Math.max(maxWidth, size.width);
                            if(this.layer.horizontalAlignment != 3)
                            {
                                // 文字間を空ける *均等以外
                                y += UnitHelper.convert(this.layer.textInfo.letterSpacing, "pt", "mm") * this.scale;
                            }
                        }
                        numberInLine++;
                        renderCharacterIndex++;

                    }
                }
            }
            // 改行
            // 改行前に同じ行にいる文字のx座標を左方向にずらす ... 描画指定位置が上中央になるため
            var horizontalArray = new Array();
            for(var i = 0; i < numberInLine; ++i)
            {
                var arrayIndex = array.length - 1 - i;
                if(arrayIndex >= 0)
                {
                    array[arrayIndex].x -= maxWidth / 2;
                }
            }

            // 行間に従って送る
            x -= maxWidth * this.layer.lineSpacing / 100;
            y = this.layer.y * this.scale + this.offsetY;
            renderLineIndex++;
            maxWidth = 0;
            numberInLine = 0;
            renderCharacterIndex = 0;
        }

        // 縦書き用文字変換
        if(UserAgentHelper.getBrowser() == "safari" && !this.isRendering && array.length > 0)
        {
            for(var i = 0; i < array.length; ++i)
            {
                if(!array[i].textInfo.isHorizontalInVertical)
                {
                    if(StringHelper.isHankaku(array[i].character))
                    {
                        // nothing
                    }
                    else
                    {
                        array[i].character = StringHelper.toVerticalString(array[i].character);
                    }
                }
            }
        }

        // 垂直方向位置 *縦書きの場合は水平方向のプロパティを垂直方向に適用する
        if(this.layer.horizontalAlignment != 0)
        {
            // 左(=上)揃え以外
            var tempArray = new Array();
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];

                // 一時配列にアイテムを加える
                tempArray.push(item);

                // 行の最後かどうかしらべる
                var isLastInLine = false;
                if(i == array.length - 1)
                {
                    // 最後のアイテム
                    isLastInLine = true;
                }
                else
                {
                    // 次のアイテムの行番号が異なる
                    isLastInLine = item.renderLineIndex != array[i + 1].renderLineIndex;
                }

                if(isLastInLine)
                {
                    // 行の最後なら垂直揃えをする
                    // 行の長さ = (行最後のアイテムのy座標 + 高さ) - (行最初のアイテムのy座標)
                    var lineWidth = tempArray[tempArray.length - 1].y + tempArray[tempArray.length - 1].height - tempArray[0].y;

                    if(this.layer.horizontalAlignment == 1 || this.layer.horizontalAlignment == 2)
                    {
                        // 中央/右(=下)揃えは同じ値だけy座標をずらす
                        var dy = 0;
                        if(this.layer.horizontalAlignment == 1)
                        {
                            // 中央揃え (レイヤーの高さ - 行の長さ) / 2
                            dy = (this.layer.height * this.scale - lineWidth) / 2;
                        }
                        else if(this.layer.horizontalAlignment == 2)
                        {
                            // 右(=下)揃え レイヤーの高さ - 行の長さ
                            dy = this.layer.height * this.scale - lineWidth;
                        }
                        for(var tempItem of tempArray)
                        {
                            tempItem.y += dy;
                        }
                    }
                    else if(this.layer.horizontalAlignment == 3)
                    {
                        // 均等揃えは字間を再設定する
                        // 文字数をカウントする。ただし半角英数記号は並びあっている限りは一文字扱いする
                        // "abc "で1文字
                        var textCount = 0;
                        for(var t = 0; t < tempArray.length; ++t)
                        {
                            var item = tempArray[t];
                            if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                            {
                                // 半角英数記号にマッチング
                                // 末尾 or 次の文字が半角英数記号以外なら文字としてカウント
                                if(t == tempArray.length - 1 || (t < tempArray.length - 1 && !(tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t + 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else if(item.character == " ")
                            {
                                // 半角スペースにマッチング
                                // 最初 or 直前の文字が半角英数記号以外なら文字としてカウント
                                if(t == 0 || (t > 1 && !(tempArray[t - 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t - 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else
                            {
                                // 文字カウント
                                textCount++;
                            }
                        }

                        if(textCount > 1)
                        {
                            // 2文字以上のみ均等割を行う
                            var spacing = (this.layer.height * this.scale - lineWidth) / (textCount - 1);
                            // 字間を設定していく
                            var dy = 0;
                            for(var t = 0; t < tempArray.length; ++t)
                            {
                                var item = tempArray[t];
                                item.y+= dy;

                                if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                                {
                                    // 半角英数記号にマッチング
                                    if(t < tempArray.length - 1 && tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) == null)
                                    {
                                        // 次の文字が半角英数記号以外
                                        dy += spacing;
                                    }
                                }
                                else
                                {
                                    dy += spacing;
                                }
                            }
                        }
                    }

                    // 一時配列クリア
                    tempArray = new Array();
                }
            }
        }

        // 水平方向位置 *縦書きの場合は垂直方向のプロパティを水平方向に適用する
        if(this.layer.verticalAlignment != 0)
        {
            // 上(=右)揃え以外
            // 全文字の一番右の座標・一番左の座標を求める
            var minX = 0;
            var maxX = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];
                if(i == 0 || item.x < minX) { minX = item.x; }
                if(i == 0 || item.x + item.width > maxX) { maxX = item.x + item.width; }
            }
            // 文字全体の幅
            var allWidth = maxX - minX;
            // 同じ値だけx座標をずらす
            var dx = 0;
            if(this.layer.verticalAlignment == 1)
            {
                // 中央揃え (レイヤーの幅 - 文字全体の幅) / 2;
                dx = (this.layer.width * this.scale - allWidth) / 2;
            }
            else if(this.layer.verticalAlignment == 2)
            {
                // 下(=左)揃え (レイヤーの幅 - 文字全体の高さ)
                dx = this.layer.width * this.scale - allWidth;
            }
            for(var item of array)
            {
                item.x -= dx;
            }
        }

        return array;
    }

    // 下線配列
    private get underlineArray() : Array<{
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        color : string,                 // 色(hex)
        uuid : string                   // UUID
    }>
    {
        var array = new Array();

        var renderLineIndex = 0;
        var renderCharacterIndex = 0;
        var tempArray = new Array();
        for(var i = 0; i < this.characterInfoArray.length; ++i)
        {
            var info = this.characterInfoArray[i];

            // レンダリングのための位置調整を元に戻す
            if(this.isRendering && this.layer.textOrientation == 1)
            {
                if(!info.textInfo.isHorizontalInVertical)
                {
                    info.x += info.width / 2;
                    if(StringHelper.isHankaku(info.character))
                    {
                        // nothing
                    }
                    else
                    {
                        info.y += -info.height / 10 * 9;
                    }
                }
            }

            // 文字情報を追加
            tempArray.push(info);
            var isLastInLine = i == this.characterInfoArray.length - 1 || this.characterInfoArray[i + 1].renderLineIndex != info.renderLineIndex;
            if(isLastInLine)
            {
                // この文字が行終了
                if(this.layer.textOrientation == 1)
                {
                    // 縦書き *傍線を右に引く

                    // 最大となるテキストの幅を求める
                    var maxWidth = 0;
                    for(var tempInfo of tempArray)
                    {
                        maxWidth = Math.max(tempInfo.width, maxWidth);
                    }
                    // 傍線の幅
                    var underlineW = maxWidth * NumberLayerDrawer.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT;
                    // 傍線の情報を追加していく
                    for(var t = 0; t < tempArray.length; ++t)
                    {
                        var tempInfo = tempArray[t];
                        if(tempInfo.character != "" && this.layer.textInfo.underline)
                        {
                            // 次の文字にアンダーラインがあるか？
                            var isNextUnderline = false;
                            if(t < tempArray.length - 1)
                            {
                                var nextTemp = tempArray[t + 1];
                                isNextUnderline = this.layer.textInfo.underline;
                            }
                            // 下線を示す矩形
                            var underlineX = tempInfo.x + maxWidth / 2;
                            var underlineY = tempInfo.y;
                            var underlineH = tempInfo.height;
                            if(isNextUnderline)
                            {
                                underlineH = tempArray[t + 1].y - tempInfo.y;
                            }
                            var underlineColor = this.layer.textInfo.textColor.hex;
                            array.push({ x : underlineX, y : underlineY, width : underlineW, height : underlineH, color : underlineColor, uuid : UuidHelper.getUuid() });
                        }
                    }
                }
                else
                {
                    // 横書き

                    // 最大となるテキストの高さを求める
                    var maxHeight = 0;
                    for(var tempInfo of tempArray)
                    {
                        maxHeight = Math.max(tempInfo.height, maxHeight);
                    }
                    // 下線の高さ
                    var underlineHeight = maxHeight * NumberLayerDrawer.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT;
                    // 下線の情報を追加していく
                    for(var t = 0; t < tempArray.length; ++t)
                    {
                        var tempInfo = tempArray[t];
                        if(tempInfo.character != "" && this.layer.textInfo.underline)
                        {
                            // 次の文字にアンダーラインがあるか？
                            var isNextUnderline = false;
                            if(t < tempArray.length - 1)
                            {
                                var nextTemp = tempArray[t + 1];
                                isNextUnderline = this.layer.textInfo.underline;
                            }
                            // 下線を示す矩形
                            var underlineX = tempInfo.x;
                            var underlineY = tempInfo.y;
                            var underlineWidth = tempInfo.width;
                            if(isNextUnderline)
                            {
                                underlineWidth = tempArray[t + 1].x - tempInfo.x;
                            }
                            var underlineColor = this.layer.textInfo.textColor.hex;
                            array.push({ x : underlineX, y : underlineY, width : underlineWidth, height : underlineHeight, color : underlineColor, uuid : UuidHelper.getUuid() });
                        }
                    }
                }

                tempArray = new Array();
            }
        }

        return array;
    }

    private getCharacterStyle(characterInfo)
    {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo),
            "fill" : characterInfo.textInfo.textColor.hex
        };
        if(isVertical)
        {
            // 縦書き
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private getWritingMode(characterInfo)
    {
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        return isVertical ? "tb" : "lr";
    }

    private isVisibleOutline(characterInfo)
    {
        return characterInfo.textInfo.isOutline;
    }

    private getOutlineStyle(characterInfo)
    {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1;
        var outlineThickness = characterInfo.fontSize * characterInfo.textInfo.outlineThickness / 750;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo),
            "fill" : "none",
            "stroke" : characterInfo.textInfo.outlineColor.hex,
            "stroke-width" : this.alternativeOutlineThickness(characterInfo) + outlineThickness,
            "stroke-linejoin" : "round",
            "opacity" : MathHelper.clamp(characterInfo.textInfo.outlineIntensity / 100, 0, 1)
        };
        if(isVertical)
        {
            // 縦書き
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private isVisibleAlternativeOutline(characterInfo) {
        return characterInfo.textInfo.bold && FontManager.UseAlternativeOutlineToBold(characterInfo.textInfo.fontId);
    }

    private alternativeOutlineThickness(characterInfo) {
        return this.isVisibleAlternativeOutline(characterInfo) ? characterInfo.fontSize * 24 / 750 : 0;
    }

    private alternativeOutlineStyle(characterInfo) {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo),
            "fill" : "none",
            "stroke" : characterInfo.textInfo.textColor.hex,
            "stroke-width" : this.alternativeOutlineThickness(characterInfo),
            "stroke-linejoin" : "round"
        };
        if(isVertical)
        {
            // 縦書き
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private isShadow(characterInfo)
    {
        return characterInfo.textInfo.isShadow;
    }

    private shadowBlurFilterId(characterInfo)
    {
        return "shadowBlurFilterId_" + characterInfo.uuid;
    }

    private blurFilterUrl(characterInfo)
    {
        return "url(#" + this.shadowBlurFilterId(characterInfo) + ")";
    }

    private getTextShadowDiviation(characterInfo)
    {
        // 出力時は影を弱くする
        var path = this.$router.currentRoute.path;
        var fix = path == "/PrintSetting" && this.isRendering ? 0.2 : 1;
        return characterInfo.textInfo.shadowBlur / 10 * fix;
    }

    private getShadowPosition(characterInfo)
    {
        // 影
        var distance = characterInfo.fontSize * 2 * characterInfo.textInfo.shadowDistance / 100;
        var radian = characterInfo.textInfo.shadowRotate * Math.PI / 180;
        var xDistance = distance * Math.cos(radian);
        var yDistance = distance * Math.sin(radian);
        return { x : characterInfo.x + xDistance, y : characterInfo.y + yDistance }
    }

    private getShadowStyle(characterInfo)
    {
        var shadowColorR = characterInfo.textInfo.shadowColor.r;
        var shadowColorG = characterInfo.textInfo.shadowColor.g;
        var shadowColorB = characterInfo.textInfo.shadowColor.b;
        var shadowColorA = MathHelper.clamp(characterInfo.textInfo.shadowIntensity / 100, 0, 1);
        var shadowColorRgba = "rgba(" + shadowColorR + "," + shadowColorG + "," + shadowColorB + "," + shadowColorA + ")";

        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo),
            "fill" : shadowColorRgba
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private getFontFamily(textInfo, isHankaku = false, isVertical = false) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyName(textInfo.fontId, isHankaku, this.isRendering && !this.isRenderingOnClient, isVertical, this.isRenderingOnClient);
    }

    private getFontWeight(textInfo) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(textInfo.fontId);
        // 太字の代わりに縁取りを使用する場合はboldをfalseとして扱う
        let bold = textInfo.bold;
        if(FontManager.UseAlternativeOutlineToBold(textInfo.fontId)) bold = false;
        // ウェイトがない場合はボールド設定を返す
        if(font.weight == null) { return bold ? "bold" : "normal"; }
        // レンダリング中はウェイト数値が無効なので、700以上かボールド設定ならボールド、それ以外ならnormalを返す
        if(this.isRendering && !this.isRenderingOnClient) { return (font.weight >= 700 || bold) ? "bold" : "normal"; }
        // ボールド設定がない場合はウェイトを返す
        if(!bold) { return font.weight.toString(); }
        // 700 = bold なので、weightがこの値より大きいならこの値を使い、それ以下のときはboldを指定する。
        return font.weight > 700 ? font.weight.toString() : "bold";
    }

    private getFontStyle(textInfo : TextInfo) : string
    {
        return textInfo.italic ? "italic" : "normal";
    }

    private get transform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // オフセット
        transform += "translate(" + -offsetX + " " + -offsetY + ")";

        return transform;
    }

    private getCharacterTransform(characterInfo) : string
    {
        var characterTransform = "";

        // レイヤーの変形
        characterTransform += this.transform + ",";

        // 文字の変形
        characterTransform += "translate(" + characterInfo.x + " " + characterInfo.y + "),";

        if(this.layer.textOrientation == 1)
        {
            // 縦書き
            characterTransform += "scale(" + "1 " + (characterInfo.letterWidth / 100) + "),";
            // if(this.isRendering && !characterInfo.textInfo.isHorizontalInVertical)
            // {
            //     // レンダリング位置調整
            //     characterTransform += "translate(" + (-characterInfo.width / 10 * 3) + " " + 0 + "),";

            //     if(StringHelper.isHankaku(characterInfo.character))
            //     {
            //         // 半角文字は90度回転
            //         characterTransform += "rotate(" + 90 + "),";
            //     }
            //     else
            //     {
            //         characterTransform += "translate(" + 0 + " " + characterInfo.height / 10 * 9 + "),";
            //     }
            // }

            // Safariで縦書きのみ位置補正
            if(!this.isRendering && UserAgentHelper.getBrowser() == "safari")
            {
                if(!StringHelper.isHankaku(characterInfo.character))
                {
                    characterTransform += "translate(" + 0 + " " + -characterInfo.height / 4 + "),";
                }
            }

            // IEで位置補正
            if(!this.isRendering && UserAgentHelper.getBrowser() == "ie")
            {
                if(!StringHelper.isHankaku(characterInfo.character))
                {
                    characterTransform += "translate(" + -characterInfo.width / 4 + " " + 0 + "),";
                }
            }
        }
        else
        {
            // 横書き
            characterTransform += "scale(" + (characterInfo.letterWidth / 100) + " 1),";
        }

        characterTransform += "translate(" + -characterInfo.x + " " + -characterInfo.y + ")";

        return characterTransform;
    }

    private calcTextSize(str : string, fontSize : number, fontId : string = "", isBold : boolean = false, isItalic : boolean = false, isVertical : boolean = false)
    {
        var isHankaku = StringHelper.isHankaku(str);

        // fontSize -> pt
        var fontSizePt = UnitHelper.convert(fontSize / this.scale, "mm", "pt");
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);

        // fontFamily
        var fontFamily = fontManager.getFontFamilyName(fontId, isHankaku, false, isVertical);

        // weight
        var weight = "normal";
        if(font.weight == null)
        {
            // ウェイトがない場合はボールド設定を返す
            weight = isBold ? "bold" : "normal";
        }
        else
        {
            // ウェイトがある場合
            if(isBold)
            {
                weight = font.weight > 700 ? font.weight.toString() : "bold";
            }
            else
            {
                weight = font.weight.toString();
            }
        }

        // style
        var style = isItalic && fontManager.canItalic(fontId, isHankaku) ? "italic" : "normal";

        var ptSize = StringHelper.calcTextSizeOnSVGPt(str, fontSizePt, fontFamily, weight, style, isVertical);

        var width = UnitHelper.convert(ptSize.width, "pt", "mm") * this.scale;
        var height = UnitHelper.convert(ptSize.height, "pt", "mm") * this.scale;

        return { width : width, height : height };
    }
}
